export const JANE_URL = 'https://thuladoulamassage.janeapp.com';
export const PHONE = '(832) 350-8516';
export const PHONE_HREF = 'tel:+18323508516';
export const EMAIL = 'Info@thuladoulamassage.com';
export const ADDRESS_LINE_1 = '5810 Wilson Rd, Suite 106';
export const ADDRESS_LINE_2 = 'Humble, TX 77396';
export const MAPS_URL = 'https://maps.google.com/?cid=15076972839093724071';
export const VA_COMMUNITY_CARE_URL =
  'https://www.va.gov/houston-health-care/programs/community-care/';
export const INSTAGRAM_URL = 'https://www.instagram.com/thuladoulamassagehtx/';
export const FACEBOOK_URL = 'https://www.facebook.com/people/Thula-Doula-Massage-HTX/61567381612758/';
export const GOOGLE_REVIEW_URL = 'https://g.page/r/Cfbpio5vGYJfEAE/review';
export const SKOOL_URL = 'https://www.skool.com/massage-practice-hub-3277/about';
export const CRISIS_LINE_URL = 'https://www.veteranscrisisline.net/';

export const IMG = {
  hero: 'https://images.unsplash.com/photo-1709755491926-f7aa83748967?auto=format&fit=crop&w=1400&q=80',
  prenatal:
    'https://images.unsplash.com/photo-1457342813143-a1ae27448a82?auto=format&fit=crop&w=1200&q=80',
  deepTissue:
    'https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?auto=format&fit=crop&w=1200&q=80',
  lymphatic:
    'https://images.unsplash.com/photo-1664549760921-2198b054a592?auto=format&fit=crop&w=1200&q=80',
  therapeutic:
    'https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?auto=format&fit=crop&w=1200&q=80',
  doula: 'https://images.unsplash.com/photo-1581952975750-75947e1874c5?auto=format&fit=crop&w=1200&q=80',
  veterans:
    'https://images.unsplash.com/photo-1492288991661-058aa541ff43?auto=format&fit=crop&w=1200&q=80',
  studio:
    'https://images.unsplash.com/photo-1787651343620-8d5303006ecb?auto=format&fit=crop&w=1200&q=80',
  calm: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=1600&q=80',
};

export const NAV_LINKS = [
  { label: 'Massage Services', path: '/massage-services', testId: 'nav-link-massage-services' },
  { label: 'Veterans', path: '/veterans', testId: 'nav-link-veterans' },
  { label: 'Virtual Doula', path: '/virtual-doula', testId: 'nav-link-virtual-doula' },
  { label: 'Practice Hub', path: '/practice-hub', testId: 'nav-link-practice-hub' },
  { label: 'About', path: '/about', testId: 'nav-link-about' },
  { label: 'FAQ', path: '/faq', testId: 'nav-link-faq' },
  { label: 'Blog', path: '/blog', testId: 'nav-link-blog' },
  { label: 'Contact', path: '/contact', testId: 'nav-link-contact' },
];

export const SERVICES = [
  {
    slug: 'prenatal-postpartum',
    num: '01',
    name: 'Prenatal & Postpartum Massage',
    short:
      'Supportive, trimester-safe bodywork for pregnancy and the recovery that follows — side-lying positioning, gentle bolstering, pressure tuned to you.',
    image: IMG.prenatal,
    benefits: [
      'Eases low-back and hip strain as your body changes',
      'Reduces swelling and supports better sleep',
      'Side-lying, fully supported positioning in every trimester',
      'Postpartum sessions focused on neck, shoulders, and deep rest',
    ],
    body: [
      'Pregnancy asks a lot of a body — and it deserves care that keeps up. Our prenatal sessions are fully supported and trimester-safe: you rest on your side with cushioned bolsters while we work through the low-back ache, hip tension, and swelling that come with each stage.',
      'After birth, postpartum massage turns toward recovery — releasing the neck and shoulder load of feeding and carrying, calming the nervous system, and giving you an uninterrupted hour that belongs only to you.',
      'We follow your provider\u2019s guidance on timing, especially in the first trimester or with high-risk pregnancies. When in doubt, ask us before booking.',
    ],
  },
  {
    slug: 'deep-tissue',
    num: '02',
    name: 'Deep Tissue Massage',
    short:
      'Slow, focused pressure that works through chronic tension, stubborn knots, and the patterns that keep coming back.',
    image: IMG.deepTissue,
    benefits: [
      'Releases chronic tension and adhesions',
      'Targets overworked shoulders, back, and hips',
      'Pressure checked with you, every step of the session',
      'Effective for posture and repetitive-strain patterns',
    ],
    body: [
      'Deep tissue work is not about brute force — it\u2019s about patience. We use slow, deliberate strokes and sustained pressure to reach the layers where chronic tension lives: desk-tight shoulders, locked-up low backs, overused hips and legs.',
      'You set the pace. We check pressure throughout your session and stay in honest communication, because productive depth should feel like release — not a battle.',
      'Most clients pair deep tissue sessions with our therapeutic work for lasting relief from long-standing patterns.',
    ],
  },
  {
    slug: 'lymphatic-drainage',
    num: '03',
    name: 'Lymphatic Drainage Massage',
    short:
      'Feather-light, rhythmic strokes that encourage lymph flow — easing swelling, supporting recovery, and restoring lightness.',
    image: IMG.lymphatic,
    benefits: [
      'Reduces swelling and puffiness',
      'Supports post-operative recovery (with surgeon clearance)',
      'Encourages the body\u2019s natural detox pathways',
      'Deeply calming for the nervous system',
    ],
    body: [
      'The lymphatic system has no pump of its own — it relies on movement, breath, and gentle external stimulation. Lymphatic drainage massage uses light, rhythmic, precisely-sequenced strokes to encourage lymph flow and help the body clear excess fluid.',
      'Clients seek it for post-surgical swelling (with their surgeon\u2019s clearance), persistent puffiness, sluggish recovery after illness, or simply the profound calm the rhythm induces.',
      'It surprises first-timers: touch this light can be this effective. Most people leave feeling lighter — visibly and literally.',
    ],
  },
  {
    slug: 'therapeutic-medical',
    num: '04',
    name: 'Therapeutic & Medical Massage',
    short:
      'Personalized bodywork for every body, every stage of life — injury recovery, chronic pain, and care that listens first.',
    image: IMG.therapeutic,
    benefits: [
      'Sessions built around your history and goals',
      'Focused care for injury recovery and chronic pain',
      'Work alongside your medical or surgical care team',
      'Pressure, pace, and focus adjusted in real time',
    ],
    body: [
      'This is our foundation: unhurried, medically-informed bodywork that begins with listening. Every session starts with an intake — where you hurt, what you\u2019ve tried, what healing would make possible — and the treatment plan follows from there.',
      'Medical massage brings focused protocols to injury recovery and chronic conditions: headaches, sciatica, frozen shoulder, post-surgical tension. It works best as a companion to your medical care, not a replacement for it.',
      'Whether you arrive with a diagnosis or a vague ache that won\u2019t quit, you\u2019ll be met with skill, attention, and a plan.',
    ],
  },
  {
    slug: 'body-sculpting',
    num: '05',
    name: 'Body Sculpting',
    comingSoon: true,
    short:
      'Non-invasive contouring treatments are on the way. Be first in line when scheduling opens.',
  },
];

export const FAQ_GROUPS = [
  {
    title: 'Booking & Your Visit',
    faqs: [
      {
        q: 'How do I book an appointment?',
        a: 'Everything is scheduled through our Jane booking page — tap any "Book a Massage" button and you\u2019ll see live availability, session lengths, and pricing instantly. No phone tag required. Prefer to talk it through first? Call us at (832) 350-8516.',
      },
      {
        q: 'What should I expect at my first visit?',
        a: 'Your care starts before the massage begins. Intake forms arrive by email when you schedule — complete them at your convenience, or in person when you arrive. Our receptionist welcomes you into the waiting area while your therapist prepares, then meets with you to review your intake, discuss your concerns and goals, and tailor the session to you.',
      },
      {
        q: 'What should I wear or remove?',
        a: 'Undress only to your comfort level. You\u2019ll be professionally draped at all times; only the area being worked on is uncovered. Prenatal and lymphatic sessions can be done fully clothed if you prefer.',
      },
      {
        q: 'Do you accept HSA/FSA cards?',
        a: 'Many clients pay with HSA or FSA cards. If you need documentation for reimbursement or your HSA administrator, just ask at checkout and we\u2019ll provide a receipt with the details they require.',
      },
    ],
  },
  {
    title: 'Prenatal & Postpartum',
    faqs: [
      {
        q: 'When can I start prenatal massage?',
        a: 'Many clients begin in the second trimester and continue through term. If you\u2019re in the first trimester or have a high-risk pregnancy, we follow your provider\u2019s guidance — check with them first, then book with confidence.',
      },
      {
        q: 'How do I lie on the table?',
        a: 'You won\u2019t. Prenatal sessions are side-lying with cushioned bolsters supporting your bump, knees, and ankles — comfortable and safe in any trimester. We never use face-down pregnancy pads.',
      },
      {
        q: 'How soon after birth can I book postpartum massage?',
        a: 'Most clients are ready within the first few weeks, but it depends on your birth and recovery. We keep postpartum sessions gentle and adjust for C-section recovery, breastfeeding tenderness, and fatigue.',
      },
    ],
  },
  {
    title: 'Policies',
    faqs: [
      {
        q: 'What is your cancellation policy?',
        a: 'Everyone: please give at least 24 hours\u2019 notice to cancel or reschedule. If your appointment is referral-based medical massage, late cancellations are tracked — a warning, then a final warning, then possible removal from the active schedule. For all other services (therapeutic, deep tissue, prenatal, lymphatic), a cancellation under 24 hours or a no-show is subject to a fee, up to the full amount of the scheduled massage.',
        link: { to: '/policies', label: 'Read the full attendance & cancellation policy' },
      },
      {
        q: 'Should I tip?',
        a: 'Gratuity is never expected and always appreciated. If massage has become part of your regular healthcare routine, many clients skip tipping and simply come back — that means the most to us.',
      },
      {
        q: 'Where do I park?',
        a: 'Free parking is available directly in front of the suite at 5810 Wilson Rd, Suite 106, Humble, TX 77396. Look for the entrance marked Suite 106.',
      },
    ],
  },
];

export const VETERAN_FAQS = [
  {
    q: 'Do you accept VA Community Care?',
    a: 'Yes. If the VA has issued you an authorization for massage therapy in the community, we can provide your care and bill through the Community Care Network. Call us at (832) 350-8516 with your referral details and we\u2019ll confirm your authorization before your first visit.',
  },
  {
    q: 'How do I get a massage therapy referral from the VA?',
    a: 'Start with your VA primary care provider or care team: tell them you\u2019re experiencing pain or tension and ask whether a Community Care referral for massage therapy is appropriate for you. If they agree, the VA issues an authorization for a set number of visits with a community provider like us.',
  },
  {
    q: 'What does my first veteran appointment involve?',
    a: 'An unhurried intake covering your service-connected conditions, current symptoms, medications, and goals — followed by a measured, first session so we can learn how your body responds. Nothing is rushed, and you stay in control of pressure and focus at all times.',
  },
  {
    q: 'Is massage safe with my conditions or medications?',
    a: 'Massage is broadly safe, but some service-connected conditions and medications (blood thinners, for example) call for technique adjustments. We review your intake carefully and coordinate with your VA provider when a question comes up.',
  },
  {
    q: 'What if my referral or authorization has expired?',
    a: 'Authorizations are issued for specific date ranges and visit counts. If yours has lapsed, contact your VA care team to request a renewal — then call us. We can often see you shortly after the new authorization is issued.',
  },
];

export const VETERAN_RESOURCES = [
  {
    title: 'VA Community Care — Houston',
    desc: 'How eligibility, referrals, and authorizations work for care provided outside VA facilities, through the Houston VA Health Care System.',
    link: VA_COMMUNITY_CARE_URL,
    linkLabel: 'va.gov/houston-health-care',
  },
  {
    title: 'Veterans Crisis Line',
    desc: 'Confidential support 24/7 for veterans and their families — no VA enrollment required.',
    link: CRISIS_LINE_URL,
    linkLabel: 'Dial 988, then press 1',
  },
  {
    title: 'VA Health Care Enrollment',
    desc: 'Not enrolled in VA health care? Start here to check eligibility and apply.',
    link: 'https://www.va.gov/health-care/apply/',
    linkLabel: 'va.gov/health-care/apply',
  },
];

export const HOURS = [
  { day: 'Monday', time: '9:00 AM – 3:00 PM' },
  { day: 'Tuesday', time: '9:00 AM – 3:00 PM' },
  { day: 'Wednesday', time: '9:00 AM – 3:00 PM' },
  { day: 'Thursday', time: '9:00 AM – 2:00 PM' },
  { day: 'Friday', time: '9:00 AM – 3:00 PM' },
];

export const POLICY = {
  intro: [
    'Thula Doula Wellness operates on a referral-based medical massage model, and appointment availability is limited — many patients are waiting for care. It is important that scheduled appointments are attended or rescheduled with appropriate notice, whichever way you book with us.',
    'This policy helps ensure that appointment time is used responsibly and that all patients have fair access to treatment.',
  ],
  sections: [
    {
      title: '24-Hour Cancellation Policy — Everyone',
      paras: [
        'All clients — private-pay and referral-based alike — must provide at least 24 hours\u2019 notice to cancel or reschedule an appointment. Providing advance notice allows us to offer the appointment time to another patient who may be waiting for care. Cancellations made less than 24 hours before the scheduled appointment will be recorded as a late cancellation.',
      ],
    },
    {
      title: 'Late Cancellations & No-Shows — All Other Clients',
      paras: [
        'This applies to every service other than referral-based medical massage: therapeutic massage, deep tissue, prenatal and postpartum massage, and lymphatic drainage.',
        'If you cancel under 24 hours or no-show your appointment, you are subject to a cancellation fee — up to and including the full amount of the scheduled massage.',
      ],
      note: 'There is no warning period for private-pay appointments: late cancellations and no-shows are charged.',
    },
    {
      title: 'Late Cancellations — Referral-Based Medical Massage Patients',
      paras: [
        'Medical massage patients booked through a referral program follow a tracked escalation schedule instead of a fee. Late cancellations are tracked within the clinic\u2019s scheduling system.',
      ],
      list: [
        'First late cancellation — patient receives a warning',
        'Second late cancellation — patient receives a final warning',
        'Third occurrence — patient may be removed from the active schedule and required to restart the referral process',
      ],
      note: 'Restarting the referral process may require a new referral from the hospital or referring provider.',
    },
    {
      title: 'Missed Appointments (No-Shows) — Medical Massage Patients',
      paras: [
        'A no-show occurs when a patient does not attend their scheduled appointment and does not notify the clinic in advance. If a medical massage patient does not show up for a scheduled appointment:',
      ],
      list: [
        'The appointment will be recorded as a no-show',
        'The patient may be removed from the active schedule',
        'The patient may be required to restart the referral process before scheduling additional appointments',
      ],
      note: 'Because referral approvals often have limited time windows, restarting the referral process may delay treatment by several weeks.',
    },
    {
      title: 'Billing and Insurance Compliance',
      paras: [
        'Medical massage services provided through referral programs must follow strict billing and compliance guidelines. At this time, missed appointments cannot be billed to insurance unless an approved billing code has been confirmed through the clinic\u2019s billing agency. For this reason, missed appointments are recorded administratively rather than billed to insurance. If future billing guidance changes, this policy may be updated accordingly.',
      ],
    },
    {
      title: 'Waitlist and Appointment Availability',
      paras: [
        'Due to high demand for medical massage services, the clinic maintains a waitlist of patients seeking care. Missed appointments and repeated late cancellations prevent other patients from receiving treatment. For this reason, the clinic may enforce scheduling limits when attendance policies are not followed.',
      ],
    },
  ],
  acknowledgment:
    'By scheduling services with Thula Doula Wellness, clients and patients acknowledge that they understand and agree to follow the clinic\u2019s appointment attendance and cancellation policies — including cancellation fees for private-pay appointments and the escalation schedule for referral-based medical massage.',
};

export const EXPECT_STEPS = [
  {
    num: '01',
    title: 'Book your first visit',
    text: 'Schedule online through Jane in under two minutes. Intake forms arrive by email — complete them beforehand, or in person when you arrive.',
  },
  {
    num: '02',
    title: 'Arrive & unwind',
    text: 'Our receptionist greets you and invites you to settle into the waiting area while your therapist prepares your room.',
  },
  {
    num: '03',
    title: 'Your tailored session',
    text: 'Your therapist reviews your intake, listens to your concerns and goals, and tailors every minute to what your body needs.',
  },
];
